import { AMEX_REGEX, DISCOVER_REGEX, MASTERCARD_REGEX, VISA_REGEX } from 'JS/helpers/regex';

export const PaymentThumbnails = {
	MasterCard: "/assets/images/credit-cards/mastercard.svg",
	Visa: "/assets/images/credit-cards/visa.svg",
	AmericanExpress: "/assets/images/credit-cards/amex.svg",
	Discover: "/assets/images/credit-cards/discover.svg",
	PayPal: "/assets/images/credit-cards/paypal.svg",
	PayPalP: "/assets/images/credit-cards/paypal-p.svg",
	BlainsCard: "/assets/images/credit-cards/blain.svg",
	ApplePay: "/assets/images/credit-cards/apple-pay.svg",
	GooglePay: '/assets/images/credit-cards/google-pay.png',
	Blank: "/assets/images/credit-cards/blank.svg",
};

export function normalizeCardType(cardType: string): string | null {
	if (["Amex","AmEx", "AmericanExpress", "American Express"].includes(cardType)) {
		return "americanexpress";
	}

	return cardType?.toLowerCase() ?? null;
}

export function getNormalizedCardTypeFromCardNumber(cardNum: string): string | null {
	if (MASTERCARD_REGEX.test(cardNum)) {
		return normalizeCardType('mastercard');
	}
	if (VISA_REGEX.test(cardNum)) {
		return normalizeCardType('visa');
	}
	if (AMEX_REGEX.test(cardNum)) {
		return normalizeCardType('americanexpress');
	}
	if (DISCOVER_REGEX.test(cardNum)) {
		return normalizeCardType('discover');
	}

	return null;
}

export function getThumbnailFromCardNumber(cardNum: string): string {
	if (!cardNum) return "/assets/images/credit-cards/blank.svg";

	if (MASTERCARD_REGEX.test(cardNum)) {
		return PaymentThumbnails.MasterCard;
	}
	if (VISA_REGEX.test(cardNum)) {
		return PaymentThumbnails.Visa;
	}
	if (AMEX_REGEX.test(cardNum)) {
		return PaymentThumbnails.AmericanExpress;
	}
	if (DISCOVER_REGEX.test(cardNum)) {
		return PaymentThumbnails.Discover;
	}
	return PaymentThumbnails.Blank;
}

export function getThumbnailFromCardType(
	cardType: string,
	{ useFullPayPalThumbnail = false }: { useFullPayPalThumbnail?: boolean } = {}
): string {
	switch (cardType) {
		case "Visa":
			return PaymentThumbnails.Visa;
		case "Mastercard":
		case "MasterCard":
			return PaymentThumbnails.MasterCard;
		case "Discover":
			return PaymentThumbnails.Discover;
		case "Amex":
		case "AmEx":
		case "AmericanExpress":
		case "American Express":
			return PaymentThumbnails.AmericanExpress;
		case "BlainsCard":
			return PaymentThumbnails.BlainsCard;
		case "PayPal":
			return useFullPayPalThumbnail
				? PaymentThumbnails.PayPal
				: PaymentThumbnails.PayPalP;
		case "ApplePay":
			return PaymentThumbnails.ApplePay;
		case "GooglePay":
			return PaymentThumbnails.GooglePay;
	}

	return PaymentThumbnails.Blank;
}

/**
 * Transforms expiration date of format m/yy or mm/yy to mm-yyyy
 * @param exp expiration date in format m/yy or mm/yy
 */
export function formatExpiration(exp: string): string {
	if (!exp) {
		return "";
	}

	const result = exp.split("/");
	if (result.length !== 2) return "";

	let month = result[0];
	const year = "20" + result[1];
	if (month.length === 1) {
		month = "0" + month;
	}
	return month + "-" + year;
}
